import React from "react";
import "../../../styles/pages/AdhocInvestigation/SummaryPanel.scss";
import { Loader } from "../../../components/Loader/Loader";
import FeedbackButtons from "./FeedbackButtons";

const SummaryPanel = ({
  data,
  loading,
  heading,
  className,
  setCommentModalData,
  traceID,
  module,
  feedbackModalText,
}) => {
  return (
    <div className={`summary-panel-container ${className}`}>
      <div className={`header summary`}>{heading}</div>
      {!loading ? (
        <>
          <div className="actions">
            <FeedbackButtons
              traceID={traceID}
              sectionData={{ module: module, text: feedbackModalText || data }}
              setCommentModalData={setCommentModalData}
              agent="adhoc"
            />
          </div>
          <div className="summary-text">{data}</div>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default SummaryPanel;
